import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import { installReportNavigation, preserveReportNavigationFlag } from '@/utils/reportNavigation';

Vue.use(VueRouter);
// 路由管理
const routes = [
  { path: '/', component: () => import('@/pages/Home'), meta: { index: 0, entryMode: 'official' } },
  { path: '/partner', component: () => import('@/pages/Home'), meta: { index: 0, entryMode: 'third-party' } },
  { path: '/redirect', component: () => import('@/pages/Redirect'), meta: { index: 0 } },
  { path: '/overview', component: () => import('@/pages/Overview'), meta: { index: 2 } },
  { path: '/assess', component: () => import('@/pages/Assess'), meta: { index: 2 } },
  { path: '/scheme', component: () => import('@/pages/Scheme'), meta: { index: 2 } },
  { path: '/details', component: () => import('@/pages/Details'), meta: { index: 3 } },
  { path: '/recuperate', component: () => import('@/pages/Recuperate'), meta: { index: 3 } },
  { path: '/nutritions', component: () => import('@/pages/Nutritions'), meta: { index: 2 } },
  { path: '/nutrition', component: () => import('@/pages/Nutrition'), meta: { index: 3 } },
  { path: '/tissue', component: () => import('@/pages/Tissue'), meta: { index: 3 } },
  { path: '/compare', component: () => import('@/pages/Compare'), meta: { index: 3 } },
  { path: '/condition', component: () => import('@/pages/Condition'), meta: { index: 3 } },
  { path: '/monthly-report', component: () => import('@/pages/MonthlyReport'), meta: { index: 2 } },
  { path: '/tongue-report', component: () => import('@/pages/TongueReport'), meta: { index: 2, hideEntryActions: true } },
  { path: '/tongue-report.html', component: () => import('@/pages/TongueReport'), meta: { index: 2, hideEntryActions: true } },
];

// const scrollPositions = {}; // 存储每个页面的滚动位置

const router = new VueRouter({
  mode: 'history',
  routes,
  // 必须组件不被缓存的情况下有效
  scrollBehavior(to, from, savedPosition) {
    // 如果存在savedPosition（通过浏览器的前进/后退按钮触发的导航），则返回savedPosition
    if (savedPosition) {
      return savedPosition;
    }
    // 如果目标路由有hash，则滚动到hash对应的元素
    if (to.hash) {
      return { selector: to.hash };
    }
    // 否则保持当前滚动位置
    return { x: 0, y: 0, behavior: 'smooth' };
  }
});

installReportNavigation(router);

// 路由守卫：语言检测和初始化
router.beforeEach(async (to, from, next) => {
  try {
    const target = preserveReportNavigationFlag(to, from);
    if (target !== to) {
      next(target);
      return;
    }

    if (to.meta?.entryMode === 'third-party') {
      store.commit('SET_THIRD_PARTY_MODE', true);
    } else if (to.meta?.entryMode === 'official') {
      store.commit('SET_THIRD_PARTY_MODE', false);
    }

    // 从当前路由的URL参数中检测语言设置
    const routeLang = to.query.lang === 'en' ? 'en-US' : 'zh-CN';
    const currentLang = store.getters.getCurrentLanguage;
    const isInitialized = store.getters.isI18nInitialized;
    
    // 如果目标路由没有lang参数，但来源路由有lang参数，则自动添加
    if (!to.query.lang && from.query.lang) {
      next({
        path: to.path,
        query: { ...to.query, lang: from.query.lang }
      });
      return;
    }
    
    // 如果未初始化或语言参数发生变化，更新语言设置
    if (!isInitialized || routeLang !== currentLang) {
      // 页面刷新时，需要重新从URL解析语言设置并更新Vuex状态
      await store.dispatch('initLanguageFromURL');
      
      console.log('路由守卫语言恢复:', {
        route: to.path,
        query: to.query,
        detectedLang: routeLang,
        previousLang: currentLang,
        isRefresh: !isInitialized
      });
    }
    
    next();
  } catch (error) {
    console.error('路由守卫语言检测失败:', error);
    // 即使语言检测失败，也要继续路由导航
    next();
  }
});

// 保存离开页面前的滚动位置
// router.beforeEach((to, from, next) => {
//   scrollPositions[from.fullPath] = window.scrollY || window.pageYOffset;
//   console.log('scrollPositions',scrollPositions)
//   next();
// });

// 进入页面后恢复滚动位置
// router.afterEach((to) => {
//   Vue.nextTick(() => {
//   console.log('scrollPositions2',scrollPositions)
//   console.log('to.fullPath',to.fullPath)

//     const y = scrollPositions[to.fullPath] || 0;
//   console.log('y',y)

//     window.scrollTo(0, y);
//   });
// });

export default router;
